<template>
  <div class="col-xs-6 col-sm-3 col-md-2">
    <label for="">
      Ano Base
    </label>
    <v-select
      class="style-chooser"
      v-model="ano_base"
      :options="retornaListaAnos()"
      :clearable="false"
      :disabled="isLoading"
      :loading="isLoading"
    >
      <template slot="no-options">
        Selecione um ano válido...
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      disabled: false
    }
  },
  methods: {
    retornaListaAnos() {
      let lista = []
      let ano = new Date().getFullYear()

      do {
        lista.push(ano)
        ano--
      } while (ano >= 2020)

      return lista
    }
  },
  computed: {
    ano_base: {
      get() {
        return this.$store.state.receitas_despesas.ano_base
      },
      set(value) {
        this.$store.commit('DESPESAS_TOGGLE_LOADING')
        this.$store
          .dispatch('atualizaAnoBase', value)
          .catch(() => {
            this.$toastr.e(
              'Houve um erro ao carregar as informações de receitas e despesas. Algumas informações não estarão disponíveis. Tente atualizar a página'
            )
          })
          .finally(() => {
            this.$store.commit('DESPESAS_TOGGLE_LOADING')
          })
      }
    },
    ...mapGetters(['isLoading'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/AnoBase.vue